import React, { useState } from "react";
import { Helmet } from "react-helmet";
import FsLightbox from "fslightbox-react";
import "../../../App.css"
import image6 from "../../../Img/Proyectos/ProyectosDesarrollo/BuceriasZaragoza/65d5037f39c94eee8918fcb0_10 Nocturna.png"
import image2 from "../../../Img/Proyectos/ProyectosDesarrollo/BuceriasZaragoza/65d503bc9db2eaaa21101a88_09 Nocturna.png"
import image3 from "../../../Img/Proyectos/ProyectosDesarrollo/BuceriasZaragoza/65d503b8627e7b5bc19f2d24_02.png"
import image4 from "../../../Img/Proyectos/ProyectosDesarrollo/BuceriasZaragoza/65d503b857e198924a41aac4_05.png"
import image5 from "../../../Img/Proyectos/ProyectosDesarrollo/BuceriasZaragoza/65d503b8627e7b5bc19f2d36_06.png"
import image1 from "../../../Img/Proyectos/ProyectosDesarrollo/BuceriasZaragoza/65d5039281beb6c25c832f85_07.png"

function ProyectoBuceriasZaragoza() {

    const [toggler, setToggler] = useState(false);

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1
    });

    function openLightboxOnSlide(number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number
        });
    }


    return (
        <>

            <Helmet>
                <title>Proyectos en Desarrollo - Bucerias Zaragoza</title>
            </Helmet>

            <FsLightbox
                toggler={lightboxController.toggler}

                sources={[
                    image1, image2, image3, image4, image5, image6
                ]}

                slide={lightboxController.slide}
            />

            <div className="container col-12 col-sm-12 col-md-12 col-lg-10 col-xl-8 col-xxl-5 mx-auto pb-4">
                <h1 className="py-4 text-center m-0 p-0">Bucerias Zaragoza</h1>
            </div>

            <div className="container position-relative">
                <img onClick={() => openLightboxOnSlide(1)} type="button" src={image1} className="w-100" alt="..." height={650} />
            </div>


            <div className="container">
                <div className="row gy-4 mt-1">

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(2)}
                            src={image2}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(3)}
                            src={image3}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(4)}
                            src={image4}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(5)}
                            src={image5}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>
                
                    <div className="col-lg-4 col-md-12">
                        <img onClick={() => openLightboxOnSlide(6)}
                            src={image6}
                            className="w-100 h-100"
                            alt="imagen proyecto"
                        />
                    </div>

                </div>
            </div>
        </>
    );
}

export default ProyectoBuceriasZaragoza;
